module.exports = __webpack_public_path__ + "img/08.ea16a700.jpg";